import { render } from "./Login.vue?vue&type=template&id=3ad0778e&scoped=true&ts=true"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"

import "./Login.vue?vue&type=style&index=0&id=3ad0778e&lang=less&scoped=true"

import exportComponent from "/root/workspace/pt-manage-plugin-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ad0778e"]])

export default __exports__